import { render, staticRenderFns } from "./sale-show-print.vue?vue&type=template&id=c0b488f2&"
import script from "./sale-show-print.vue?vue&type=script&lang=js&"
export * from "./sale-show-print.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports